module.exports = __webpack_public_path__ + "images/stickers/laugh@2x.6a4570e57d1e3df87014.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/laugh@2x.png
// module id = lnZa
// module chunks = 12